<template>
  <div class="login-page">
    <div class="login-contents">
      <div class="login-contents__abceed">abceed store</div>
      <div class="login-contents__ttl">ログイン</div>
      <div class="login">
        <div class="login-input-text">
          <input type="email" class="login__name form-text" id="abceed-user-email" v-model="email" placeholder="メールアドレス">
        </div>
        <div class="login-input-text">
          <input type="password" class="login__email form-text" id="abceed-user-password" v-model="password" placeholder="パスワード" @keyup.enter="onLogin">
        </div>
        <div class="password-forget"><a href="javascript:void(0);" @click="passwordReset">パスワードを忘れた場合</a></div>
        <span class="btn-square" @click="onLogin">ログイン</span>
        <div class="password-forget" style="margin-top: 20px;"><a href="https://app.abceed.com">Web上で学習を行いたい方はこちら</a></div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    title: 'ログイン | abceed store',
    headerTitle: 'ログイン',
    description: 'abceed store のログインはこちら',
    keywords: 'toeic,abceed,globee,ログイン',
    headerType: 'default',
    data() {
      return {
        email: "",
        password: ""
      }
    },
    methods: {
      onLogin() {
        if (this.validation()) {
          this.$store.dispatch("showLightBox", "loading");
          this.$store.dispatch("login", {
            email: this.email,
            password: this.password
          }).then(data => {
            this.$store.dispatch("hideLightBox");
            if (data.session) {
              this.loginSuccess();
            } else {
              this.loginFailed();
            }
          }).catch(() => {
            this.$store.dispatch("hideLightBox");
          });
        } else {
          alert("Emailまたはパスワードが未入力です。");
        }
      },
      validation() {
        return this.email && this.password;
      },
      loginSuccess() {
        if (window.localStorage.getItem(['sessionToken'])) {
          // this.$store.dispatch("initData");
          if (this.$route.query.from) {
            this.$router.push({path: this.$route.query.from});
          } else {
            this.$router.push({name: 'rankingHome'});
          }
        }
      },
      loginFailed() {
        alert("emailとpasswordが異なります。");
      },
      passwordReset() {
        this.$store.dispatch("showLightBox", "passwordReset");
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-page {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    left: 0;
    top: 15px;
    bottom: 15px;
    background: #fff;
    position: fixed;
    .login-contents {
      &__ttl {
        font-weight: normal;
        font-size: 3.8rem;
        text-align: center;
      }
      &__abceed {
        color: #FF5B60;
        font-size: 4.2rem;
        letter-spacing: 0.02em;
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-weight: bold;
        text-align: center;
        margin-bottom: 30px;
      }
    }
    .password-forget {
      font-size: 1.2rem;
      text-align: center;
      margin-top: -2px;
      margin-bottom: 40px;
      a {
        color: #ee1313;
        transition: 0.3s;
        &:hover {
          text-decoration: none;
          opacity: 0.6;
          transition: 0.3s;
        }
      }
    }
    .login-maintain {
      padding: 20px 0 30px;
      font-size: 1.2rem;
      color: #b3b2b2;
      text-align: center;
    }
    .login-input-text {
      input {
        padding: 5px;
        height: 42px;
        padding: 0 10px;
        font-size: 1.6rem;
        border-radius: 3px;
      }
    }
    .login-submit-text {
      font-size: 2.8rem;
      text-align: center;
      a {
        color: #ee1313;
        transition: 0.3s;
        &:hover {
          text-decoration: none;
          opacity: 0.6;
          transition: 0.3s;
        }
      }
    }
    .login {
      width: 360px;
      padding: 5px 24px 34px;
      margin: 0 auto;
      .input-label {
        font-size: 1.6rem;
        text-align: left;
      }
      .form-text {
        margin-bottom: 10px;
        width: calc(100% - 20px);
        height: 32px;
        padding: 5px 10px;
        box-sizing: content-box;
        line-height: 32px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/Home.vue